import script from "./TextEditableRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditableRichText.vue?vue&type=script&setup=true&lang=js"

import "./TextEditableRichText.vue?vue&type=style&index=0&id=def8bd8e&lang=scss"

const __exports__ = script;

export default __exports__